import { Button, ButtonProps } from '@cp/ds/src/components/button';
import React from 'react';
import { mergeSx } from '@cp/ds/src/utils/sx/merge';
import { useTheme } from '@cp/ds/src/hooks';
import { Tooltip } from '@cp/ds/src/components/tooltip';
import { Box } from '@cp/ds/src/components/box';
import Shield from 'src/assets/shapes/shield.svg';

export const Verified = ({ isVerified }: { isVerified: boolean }) => {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  const handleOpenToggle: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation();
    setOpen(!open);
  };

  const handleMouseEnter = () => {
    setOpen(true);
  };

  const handleMouseLeave = () => {
    setOpen(false);
  };

  const buttonProps: ButtonProps = {
    variant: 'secondary',
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onClick: handleOpenToggle,
    sx: mergeSx({
      display: isVerified ? 'flex' : 'none',
      alignItems: 'center',
      color: theme.palette['brand gray'],
      width: { xs: '28px', md: '32px' },
      height: { xs: '28px', md: '32px' },
      borderRadius: '6px',
      backgroundColor: theme.palette.white,
      borderColor: theme.palette['gray light'],
      zIndex: 99,
      '&:hover': {
        color: theme.palette['brand pink'],
      },
    }),
  };

  return (
    <Tooltip
      arrow
      colorSchema="dark"
      disableFocusListener
      disableHoverListener
      disableTouchListener
      open={open}
      placement="bottom"
      slotProps={{
        popper: {
          disablePortal: true,
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 0],
              },
            },
          ],
        },
      }}
      title={<Box sx={{ px: 1.5, py: 0.75 }}>Проверен</Box>}
    >
      <Button {...buttonProps} square>
        <Box sx={{ width: { xs: '16px', md: '20px' }, display: 'flex', alignItems: 'center' }}>
          <Shield />
        </Box>
      </Button>
    </Tooltip>
  );
};
